import { render, staticRenderFns } from "./UpsertUserDialog.vue?vue&type=template&id=2874bf8a&scoped=true&"
import script from "./UpsertUserDialog.vue?vue&type=script&lang=js&"
export * from "./UpsertUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpsertUserDialog.vue?vue&type=style&index=0&id=2874bf8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874bf8a",
  null
  
)

export default component.exports